module.exports = __webpack_public_path__ + "8d1956e74b7aae9e65c85c90bcd4d862.svg";